import { render, staticRenderFns } from "./page-popular.vue?vue&type=template&id=3a51f3c2&scoped=true"
import script from "./page-popular.vue?vue&type=script&lang=js"
export * from "./page-popular.vue?vue&type=script&lang=js"
import style0 from "./page-popular.vue?vue&type=style&index=0&id=3a51f3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51f3c2",
  null
  
)

export default component.exports